



























































import { Component, Vue, Ref, Prop, Watch } from "vue-property-decorator";
import { tns } from "tiny-slider/src/tiny-slider";
import BlogCard from "./blog-card.vue";

@Component({
    components: {
        BlogCard
    }
})
export default class BlogSpotlight extends Vue {
    @Prop({ default: () => [] }) articles!: any;

    @Prop() categories?: number[];

    @Prop() exclude?: number[];

    @Ref() readonly spotlightSlider!: HTMLElement;

    slider: any = null;

    loading: boolean = false;

    params: BlogParams = { per_page: 3, page: 1, blog_categories: [] };

    localArticles: any = [];

    private async getArticles() {
        this.loading = true;

        if (this.categories) {
            this.params.blog_categories = this.categories;
        }

        // @ts-ignore
        return axios
            .get("/api/articles", { params: { ...this.params } })
            .then((response: any) => {
                return response.data.data;
            })
            .finally(() => (this.loading = false));
    }

    getArticleTitle(article: any) {
        //console.log(article);

        if (article.title) {
            return article.title.rendered;
        }
        if (article.post_title) {
            return article.post_title;
        }

        return "";
    }

    private initSlider() {
        // @ts-ignore
        if (this.$mq === "sm" || this.$mq === "md") {
            this.$nextTick(() => {
                // @ts-nocheck
                this.slider = tns({
                    container: this.spotlightSlider,
                    items: 1.1,
                    gutter: 24,
                    preventScrollOnTouch: "force",
                    mouseDrag: true,
                    loop: false,
                    controls: false,
                    swipeAngle: false,
                    nav: false,
                    responsive: {
                        768: {
                            items: 2.1,
                            gutter: 24
                        }
                    }
                });
            });
        }
    }

    @Watch("articles", { immediate: true })
    handleArticlesChanged(articles: any) {
        if (articles.length > 0) {
            this.localArticles = articles;
            this.params.exclude = articles.map((a: { id: number }) => a.id);
        }

        if (this.exclude) {
            this.params.exclude?.concat(this.exclude);
        }

        if (articles.length < 3) {
            this.params.per_page = 3 - articles.length;
            this.getArticles().then((data: any) => {
                this.localArticles = this.localArticles.concat(data);

                return this.initSlider();
            });
        }

        return this.initSlider();
    }
}
